import React from 'react'
// @src imports
import connect from 'src/redux/connect'
import Plans from 'src/marketing/plans/containers/Plans'
import CardCatalog from 'src/catalog/containers/CardCatalog'
import { openLaunchPage } from 'src/redux/actions/routeAliases'
import { AppRoute } from 'src/app/routes/AppRoute'
import { BaseRoute } from 'src/routes/BaseRoute'
import { PricingRoute } from 'src/marketing/plans/routes/PricingRoute'
import { CatalogRoute } from 'src/catalog/routes/CatalogRoute'
import { PromoRoute } from 'src/promo/routes/PromoRoute'
// marketing pages to decouple
import Storefront from 'src/marketing/storefront/containers/Storefront'
import LaunchPage from 'src/marketing/containers/LaunchPage'
import BusinessPage from 'src/marketing/containers/BusinessPage'
import { FunnelPageRoute } from 'src/marketing/storefront/routes/FunnelPageRoute'
import { BusinessRoute } from 'src/marketing/routes/BusinessRoute'
import Promo from 'src/promo/containers/Promo'

type RouterProps = Readonly<{
  route: BaseRoute
  openLaunchPage: () => void
}>

type AppRouterProps = {
  route: AppRoute
}

const AppRouter: React.FC<AppRouterProps> = ({ route }) => {
  if (!route.subroute) {
    return <LaunchPage />
  }
  switch (route.subroute.path) {
    case BusinessRoute.path:
      return <BusinessPage route={route.subroute} />
    case PricingRoute.path:
      return <Plans route={route.subroute} />
    case CatalogRoute.path:
      return <CardCatalog route={route.subroute} />
    case PromoRoute.path:
      return <Promo />
  }
}

const Router: React.FC<RouterProps> = ({ route }) => {
  if (!route.subroute) {
    return <LaunchPage />
  }
  switch (route.subroute.path) {
    case FunnelPageRoute.path:
      return <Storefront route={route.subroute} />
    case AppRoute.path:
      return <AppRouter route={route.subroute} />
  }
}

export default connect(({ route }) => ({ route }), { openLaunchPage })(Router)
